"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaSubTypeEnum = exports.AreaSubType = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const defaultAreaSubTypes = ['Coverage'];
exports.AreaSubType = [...defaultAreaSubTypes, ...(config_1.default.ventureTypeExtensions?.Area?.subtype || [])];
exports.AreaSubTypeEnum = (0, iotv_v3_types_1.getEnumShape)(exports.AreaSubType);
